<template>
  <div>
    <template v-if="loading">
      <div class="py-20">
        <vue-loading
          background-color="rgba(0,0,0,0.0)"
          :color="loadingColor"
          width="100"
          height="100"
          :is-full-page="false"
          :active="loading"
        />
      </div>
    </template>
    <template v-else>
      <template v-if="pendingLicenses === 0">
        <div class="flex flex-col justify-center items-center pb-12 pt-16">
          <div class="h-40">
            <graphic-base height="100%" width="100%" :viewBox="'0 0 160 120'">
              <EmptyStateSVG />
            </graphic-base>
          </div>
          <p :class="primaryTextClass" class="text-base leading-5 pt-4 font-normal">{{$t("message.LicensesHistoryComponent.tabs.licensesForApproval.noLicensesForApprovalTitle")}}</p>
        </div>
      </template>
      <template v-else >
        <div class=" pt-10" >
        <zt-list-item
          v-for="(item, index) in pendingApprovalLicenses"
          :key="index"
          :to="{name: 'pendingDetail', params: {'license': item}}"
          class="mt-1"
        >
          <template slot="icon">
            <div class="w-full pl-3">
              <span :class="primaryTextClass" class="text-zt-lg font-bold">{{ item.nombre }} {{ item.apellido }}</span>
              <div class="text-zt-dark-500 flex flex-wrap">
                <span>
                  {{ item.tipo_licencia }} - {{ item.dias }}
                  <template v-if="item.dias > 1"> {{ $t("message.LicensesHistoryComponent.tabs.licensesForApproval.days") }}</template>
                  <template v-else> {{ $t("message.LicensesHistoryComponent.tabs.licensesForApproval.day") }}</template>
                </span>
                <span>
                  <zt-icon name="calendar" /> {{ $t("message.LicensesHistoryComponent.tabs.licensesForApproval.from") }} {{ item.fecha_desde }} {{ $t("message.LicensesHistoryComponent.tabs.licensesForApproval.to") }} {{ item.fecha_regreso }}
                </span>
              </div>
            </div>
          </template>
          <div class="mr-3 px-2 m-auto text-zt-xl order-last font-extrabold">
            <zt-icon name="angle-right-solid" color="primary" />
          </div>
        </zt-list-item>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import Licenses from "@/apiClient/Licenses"
import { mapGetters, mapActions, mapState } from "vuex"
import { useWindowResize } from '@sichern/ui-elements'
import graphicBase from '@/components/commons/Illustrations/graphicBase'
import EmptyStateSVG from '@/components/commons/Illustrations/graphicSVG/graphicEmptyState'

export default {
  data() {
    return {
      loading: false,
      pendingLicenses: 0,
      pendingApprovalLicenses: [],
    }
  },
  components: {
    graphicBase,
    EmptyStateSVG
  },
  computed: {
    ...mapGetters({
      getUser: 'getUser'
    }),
    ...mapState('licenses', ['pendingApproval']),
    isInIframe() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid()
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200'
    },
    loadingColor() {
      return this.isInIframe ? '#2694fc' : '#4f41a3'
    }
  },
  async created() {
    this.loading = true
    let idUser = this.getUser.id;
    await this.setPendingApproval({idUser});
    this.pendingLicenses = this.pendingApproval.length
    this.pendingApprovalLicenses = this.pendingApproval
    this.loading = false
  },
  methods: {
    ...mapActions('licenses', ['setPendingApproval'])
  }

}
</script>

<style lang="scss" scoped>
  ::v-deep .zt-listitem--item__link {
    div.w-full:nth-child(2){
      display: none;
    }
  }

  /* Clase helper para texto primario en iframe */
  .text-iframe-primary {
    color: #2694fc !important;
  }
</style>